import React, { Component } from 'react';
import { connect } from 'react-redux';
import IdleTimer from 'react-idle-timer';
import { ToastContainer } from 'react-toastify';

import '../styles/App.css';
import Home from '../components/Home';
import Login from '../containers/Login';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import NavBar from '../components/NavBar/NavBar';
import MainNav from './MainNav';
import AllUsers from '../containers/AllUsers';
import ChildAccounts from '../containers/ChildAccounts';
import AllSubs from '../containers/AllSubs';
import SearchSubs from '../containers/SearchSubs';
import SearchAttSubs from '../containers/SearchSubs/att';
import SearchTracfoneSubs from '../containers/SearchSubs/tracfone';
import SearchUsers from '../containers/SearchUsers';
import ViewUser from '../containers/ViewUser';
import EditUser from '../containers/EditUser';
import CreateUser from '../containers/CreateUser';
import CreateAddress from '../containers/CreateAddress';
import UpdateContract from '../containers/UpdateContract/UpdateContract';
import CreateDevice from '../containers/CreateDevice/CreateDevice';
import ViewContract from '../containers/ViewContract';
import AllInsuranceContracts from '../containers/AllInsuranceContracts';
import ViewDevice from '../containers/ViewDevice';
import EditAttSub from './EditSub/att';
import ViewSub from '../containers/ViewSub/';
import UpdatePort from '../containers/UpdatePort';
import PortModify from '../containers/PortModify';
import PortCancel from '../containers/PortCancel/';
import NewPort from '../containers/NewPort';
import ActivateSub from '../containers/ActivateSub';
import NewMdnActivationForm from '../components/activation/NewMdnActivationForm';
import DailyUsagePage from '../containers/DailyUsagePage';
import ViewPortInfo from '../containers/ViewPortInfo';
import UserPurchases from 'containers/UserPurchases';
import ViewPurchase from 'containers/ViewPurchase';
import AddLineItems from 'containers/AddLineItems';
import UserCredit from 'containers/UserCredit';
import UserLogs from 'containers/UserLogs';
import SubLeases from 'containers/SubLeases';
import ViewLease from 'containers/ViewLease';
import ViewCredit from 'containers/ViewCredit';
import { loginCheck, logout } from 'actions/login';
import { getIsLoggedIn, getLoggedInUser } from 'reducers';
import AllAttSubs from 'containers/AllAttSubs';
import ViewAttSub from 'containers/ViewSub/att';
import AttCreateSub from 'containers/CreateSub/att';
import AttUpdateDevice from 'containers/UpdateDevice/att';
import AttUpdatePlan from 'containers/UpdatePlan/att';
import AttSetUpcomingPlan from 'containers/SetUpcomingPlan/att';
import AttActivateSub from 'containers/ActivateSub/att';
import AttExpireSubscription from 'containers/ExpireSubscription/att';
import AttCreateContract from '../containers/CreateContract/att';
import AttSubLeases from 'containers/SubLeases/att';
import AttUpgradeInvoice from 'containers/UpgradeInvoice/att';
import AttChangeMDN from 'containers/ChangeMDN/att';
import AttTransferSubscription from 'containers/TransferSubscription/att';
import UserPaymentMethods from 'containers/UserPaymentMethods';
import UserPaymentMethodsView from 'containers/UserPaymentMethodView/UserPaymentMethodView';
import UserPreactivations from 'components/preactivations/UserPreactivations';
import ViewPreactivation from 'components/preactivations/ViewPreactivation';
import PaymentArrangement from 'containers/PaymentArrangement';
import PendingArrangements from 'containers/PendingArrangements';
import ViewOrders from 'containers/ViewOrders';
import Order from 'components/Orders/Order';
import LineItemTransfer from 'containers/LineItemTransfer';
import UpdateLease from './UpdateLease';
// import AttNewLease from './NewLease/att';
import AttUpdateLease from './UpdateLease/att';
// import CreateBuyoutPurchase from 'containers/CreateBuyoutPurchase';
import SprintCallRecords from 'containers/SendRecords';
import MergePurchases from './MergePurchases/MergePurchases';
import UpdatePaymentProfile from 'containers/UpdatePaymentProfile/index';
import SwitchToAtt from 'containers/SwitchToAtt';
import SwitchToSprint from 'containers/SwitchToSprint';
import { USER_DASHBOARD_URL, INTERCOM_ID } from '../constants';
import UpdateCreator from './UpdateCreator';
import AttVerificationCode from './VerificationCode/att';
import ViewDeviceContract from './ViewDeviceContract';
import ViewRollingArrangement from './ViewRollingArrangement';
import RollingArrangements from './RollingArrangements';
import EditRollingArrangement from './EditRollingArrangement/EditRollingArrangement';
import UserRollingArrangement from './UserRollingArrangement';
import ShippingEstimate from 'containers/ShippingEstimate';
import Reseller from 'containers/Reseller';
import AttReseller from 'containers/Reseller/att';
import Intercom from '../components/Intercom';
import AllTracfoneSubs from 'containers/AllTracfoneSubs';
import TracfoneViewSub from 'containers/ViewSub/tracfone';
import TracfoneSubLeases from 'containers/SubLeases/tracfone';
import LoggedInDevices from './UserLoggedInDevices';
import SubSearch from './SubSearch/SubSearch';
// import OrderSim from './OrderSim/OrderSim';
// import OrderSimBusinessUsers from './OrderSim/OrderSimBusinessUsers';
import CustomPlanPricing from 'containers/CustomPlanPricing';
import ViewCustomPlanPricing from '../containers/ViewCustomPlanPricing';
import CreateCustomPlanPricing from '../containers/CreateCustomPlanPricing';
import RouteWatcher from '../decorators/RouteWatcher';
import BusinessUserRateCardNotFound from 'components/BusinessUserRateCardNotFound/BusinessUserRateCardNotFound';
// import OrderDevice from './OrderDevice';
import SimoCreateSub from 'containers/CreateSub/simo';
import ViewSimoSub from 'containers/ViewSub/simo';
import AllSimoSubs from 'containers/simo/AllSimoSubs';
import EditSimoSub from './EditSub/simo';
import SimoActivateSub from 'containers/ActivateSub/simo';
import SimoUpdatePlan from 'containers/UpdatePlan/simo';
import SimoSetUpcomingPlan from 'containers/SetUpcomingPlan/simo';
import SimoAutoRenew from 'containers/simo/AutoRenew';
import SimoExpireSubscription from 'containers/ExpireSubscription/simo';
import SearchSimoSubs from 'containers/SearchSubs/simo';
import SimoActivationRenewal from 'containers/simo/SimoActivationRenewal';
import SimoSubLeases from 'containers/SubLeases/simo';
import SimoNewLease from 'containers/NewLease/simo';
import SimoUpdateLease from './UpdateLease/simo';
// import SimoTopUps from './simo/SimoTopUps';
// import GenTopUpInvoice from './simo/GenTopUpInvoice';
import SimoUpgradeInvoice from 'containers/UpgradeInvoice/simo';
import ViewAnalytics from './ViewAnalytics';
import ViewSqlReports from './ViewSqlReports';
import ViewSqlReport from './ViewSqlReport';
import SqlReportQuery from './SqlReportQuery';
import CreateCredit from './CreateCredit';
import AllSimoDevices from './simo/AllSimoDevices';
import SearchSimoDevices from './simo/SearchSimoDevices/simo';
import ViewSimoDevice from './simo/ViewSimoDevice';
import CreateSimoDevice from './simo/CreateSimoDevice';
import TransferSimoDevice from './simo/TransferSimoDevice';
import PurchaseMassActions from './MassActions/PurchasesMassActions';
import AttMassActions from './MassActions/SubsMassActions/att';
import SimoMassActions from './MassActions/SubsMassActions/simo';
import QuickMassActions from './MassActions/SubsMassActions/quick';
import QuickCreateSub from 'containers/CreateSub/quick';
import AllQuickSubs from 'containers/quick/AllQuickSubs';
import SearchQuickSubs from '../containers/SearchSubs/quick';
import ViewQuickSub from 'containers/ViewSub/quick';
import QuickNewPort from './NewPort/quick';
import QuickUpdatePort from 'containers/UpdatePort/quick';
import QuickPortCancel from 'containers/PortCancel/quick';
import QuickTransferSubscription from 'containers/TransferSubscription/quick';
import QuickCreateContract from '../containers/CreateContract/quick';
import QuickVerificationCode from './VerificationCode/quick';
import QuickPreActivations from 'containers/quick/PreActivations';
import QuickPortOuts from 'containers/quick/PortOuts';
import QuickCarrierRequests from 'containers/quick/CarrierRequests';
import QuickMdnHistory from './quick/MdnHistory';
import CreateChildUser from './CreateChildUser';

class App extends Component {
  INACTIVE_USER_TIMEOUT = 1000 * 60 * 60 * 3; // 3 hours

  componentDidMount() {
    this.props.loginCheck();
  }

  redirectUserToDashboard = () => {
    window.location.href = USER_DASHBOARD_URL;
    return null;
  };

  handleOnIdle = () => {
    this.props.logout();
  };

  render() {
    const { isLoggedIn, user, loggedInUser } = this.props;
    if (isLoggedIn && user.acl_group_name === 'USER') {
      return this.redirectUserToDashboard();
    }

    return (
      <BrowserRouter>
        <div className="App">
          <RouteWatcher />
          <Route path="/" component={NavBar} />
          <div className="container">
            <div className="col-lg-2 sidebar">
              <Route path="/" component={MainNav} />
            </div>
            <div className="col-lg-10">
              {isLoggedIn && (
                <IdleTimer
                  timeout={this.INACTIVE_USER_TIMEOUT}
                  onIdle={this.handleOnIdle}
                  debounce={250}
                  crossTab={{
                    emitOnAllTabs: true,
                  }}
                />
              )}
              {isLoggedIn && (
                <Switch>
                  <Route
                    path="/"
                    exact
                    render={(props) => (
                      <Home {...props} loggedInUser={loggedInUser} />
                    )}
                  />
                  <Route path="/users" exact component={AllUsers} />
                  <Route
                    path="/users/:userId/child-accounts"
                    exact
                    component={ChildAccounts}
                  />
                  <Route path="/users/page/:page" exact component={AllUsers} />
                  <Route path="/users/search" exact component={SearchUsers} />
                  <Route
                    path="/users/search/page/:page"
                    exact
                    component={SearchUsers}
                  />
                  <Route path="/users/new" exact component={CreateUser} />
                  <Route
                    path="/users/:userId/view"
                    exact
                    component={ViewUser}
                  />
                  <Route
                    path="/users/:userId/update-creator"
                    exact
                    component={UpdateCreator}
                  />
                  <Route
                    path="/users/:userId/edit"
                    exact
                    component={EditUser}
                  />
                  <Route
                    path="/users/:userId/new-address"
                    exact
                    component={CreateAddress}
                  />
                  <Route
                    path="/users/:userId/att/new-subscription"
                    exact
                    component={AttCreateSub}
                  />
                  <Route
                    path="/users/:userId/purchases"
                    exact
                    component={UserPurchases}
                  />
                  <Route
                    path="/users/:userId/credits"
                    exact
                    component={UserCredit}
                  />
                  <Route
                    path="/users/:userId/credits/create"
                    exact
                    component={CreateCredit}
                  />
                  <Route
                    path="/users/:userId/logs"
                    exact
                    component={UserLogs}
                  />
                  {/* <Route path="/users/:userId/create-buyout-purchase" exact component={CreateBuyoutPurchase} /> */}
                  <Route
                    path="/users/:userId/payment-methods/:paymentId/view"
                    exact
                    component={UserPaymentMethodsView}
                  />
                  <Route
                    path="/users/:userId/payment-methods/update"
                    exact
                    component={UpdatePaymentProfile}
                  />
                  <Route
                    path="/users/:userId/payment-methods/update-echeck"
                    exact
                    component={UpdatePaymentProfile}
                  />
                  <Route
                    path="/users/:userId/payment-methods"
                    exact
                    component={UserPaymentMethods}
                  />
                  <Route
                    path="/users/:userId/preactivations"
                    exact
                    component={UserPreactivations}
                  />
                  <Route
                    path="/users/:userId/rolling-payments"
                    exact
                    component={UserRollingArrangement}
                  />
                  <Route
                    path="/users/:userId/rolling-payments/:rollingArrangementId/edit"
                    exact
                    component={EditRollingArrangement}
                  />
                  <Route
                    path="/users/:userId/login-devices"
                    exact
                    component={LoggedInDevices}
                  />
                  {/* <Route path="/users/:userId/order-sim" exact component={OrderSim} /> */}
                  {/* <Route path="/users/:userId/order-sim-device-business" exact component={OrderSimBusinessUsers} /> */}
                  {/* <Route path="/users/:userId/device-ordering-portal-business" exact component={OrderDevice} /> */}
                  <Route
                    path="/users/:userId/rate-card"
                    exact
                    component={BusinessUserRateCardNotFound}
                  />
                  <Route
                    path="/users/:userId/create-child"
                    exact
                    component={CreateChildUser}
                  />
                  <Route
                    path="/rolling-arrangements"
                    exact
                    component={RollingArrangements}
                  />
                  <Route
                    path="/rolling-arrangements/:rollingArrangementId/view"
                    exact
                    component={ViewRollingArrangement}
                  />
                  <Route
                    path="/rolling-arrangements/:rollingArrangementId/edit"
                    exact
                    component={EditRollingArrangement}
                  />
                  <Route
                    path="/credits/:creditId/view"
                    exact
                    component={ViewCredit}
                  />
                  <Route
                    path="/purchases/:purchaseId/view"
                    exact
                    component={ViewPurchase}
                  />
                  <Route
                    path="/purchases/:purchaseId/merge"
                    exact
                    component={MergePurchases}
                  />
                  <Route
                    path="/purchases/:purchaseId/payment-arrangement"
                    exact
                    component={PaymentArrangement}
                  />
                  <Route
                    path="/purchases/:purchaseId/transfer-line-items"
                    exact
                    component={LineItemTransfer}
                  />
                  <Route
                    path="/purchases/:purchaseId/add-items"
                    exact
                    component={AddLineItems}
                  />
                  <Route
                    path="/purchases/payment-arrangement"
                    exact
                    component={PendingArrangements}
                  />
                  <Route path="/orders" exact component={ViewOrders} />
                  <Route path="/orders/:id" exact component={Order} />
                  <Route path="/metrics" exact component={ViewAnalytics} />
                  <Route
                    path="/reporting/automated-reports"
                    exact
                    component={ViewSqlReports}
                  />
                  <Route
                    path="/reporting/automated-reports/:sqlReportId/view"
                    exact
                    component={ViewSqlReport}
                  />
                  <Route
                    path="/reporting/automated-reports/:sqlReportId/report-queries/:sqlReportQueryId/view"
                    exact
                    component={SqlReportQuery}
                  />
                  <Route
                    path="/preactivations/:preactivationId/view"
                    exact
                    component={ViewPreactivation}
                  />
                  <Route
                    path="/att/subscriptions"
                    exact
                    component={AllAttSubs}
                  />
                  <Route
                    path="/att/subscriptions/page/:page"
                    exact
                    component={AllAttSubs}
                  />
                  <Route
                    path="/att/subscriptions/:subId/view"
                    exact
                    component={ViewAttSub}
                  />
                  <Route
                    path="/att/subscriptions/:subId/update-device"
                    exact
                    component={AttUpdateDevice}
                  />
                  <Route
                    path="/att/subscriptions/:subId/update-plan"
                    exact
                    component={AttUpdatePlan}
                  />
                  <Route
                    path="/att/subscriptions/:subId/upcoming-plan"
                    exact
                    component={AttSetUpcomingPlan}
                  />
                  <Route
                    path="/att/subscriptions/:subId/activate"
                    exact
                    component={AttActivateSub}
                  />
                  <Route
                    path="/att/subscriptions/:subId/expire-subscription"
                    exact
                    component={AttExpireSubscription}
                  />
                  <Route
                    path="/att/subscriptions/:subId/leases"
                    exact
                    component={AttSubLeases}
                  />
                  <Route
                    path="/att/subscriptions/:subId/change-mdn"
                    exact
                    component={AttChangeMDN}
                  />
                  {/* <Route path="/att/subscriptions/:subId/new-lease" exact component={AttNewLease} /> */}
                  <Route
                    path="/att/subscriptions/:subId/upgrade-invoice"
                    exact
                    component={AttUpgradeInvoice}
                  />
                  <Route
                    path="/att/subscriptions/:subId/transfer-subscription"
                    exact
                    component={AttTransferSubscription}
                  />
                  <Route
                    path="/att/subscriptions/search"
                    exact
                    component={SearchAttSubs}
                  />
                  <Route
                    path="/att/subscriptions/search/page/:page"
                    exact
                    component={SearchAttSubs}
                  />
                  <Route
                    path="/att/subscriptions/:subId/contracts/create-contract"
                    exact
                    component={AttCreateContract}
                  />
                  <Route
                    path="/att/subscriptions/:subId/verification-code"
                    exact
                    component={AttVerificationCode}
                  />
                  <Route
                    path="/att/subscriptions/:subId/update-lease/:leaseId"
                    exact
                    component={AttUpdateLease}
                  />
                  <Route
                    path="/att/subscriptions/:subId/edit"
                    exact
                    component={EditAttSub}
                  />
                  <Route
                    path="/att/subscriptions/:subId/start-switch-to-sprint"
                    exact
                    component={SwitchToSprint}
                  />
                  <Route
                    path="/att/subscriptions/:subId/confirm-switch-to-sprint"
                    exact
                    component={SwitchToSprint}
                  />
                  <Route
                    path="/tracfone/subscriptions/:subId/view"
                    exact
                    component={TracfoneViewSub}
                  />
                  <Route
                    path="/tracfone/subscriptions/:subId/leases"
                    exact
                    component={TracfoneSubLeases}
                  />
                  <Route
                    path="/tracfone/subscriptions"
                    exact
                    component={AllTracfoneSubs}
                  />
                  <Route
                    path="/tracfone/subscriptions/page/:page"
                    exact
                    component={AllTracfoneSubs}
                  />
                  <Route
                    path="/tracfone/subscriptions/search"
                    exact
                    component={SearchTracfoneSubs}
                  />
                  <Route
                    path="/tracfone/subscriptions/search/page/:page"
                    exact
                    component={SearchTracfoneSubs}
                  />
                  <Route
                    path="/users/:userId/simo/new-subscription"
                    exact
                    component={SimoCreateSub}
                  />
                  <Route
                    path="/users/:userId/simo/new-device"
                    exact
                    component={CreateSimoDevice}
                  />
                  <Route
                    path="/simo/subscriptions"
                    exact
                    component={AllSimoSubs}
                  />
                  <Route
                    path="/simo/subscriptions/page/:page"
                    exact
                    component={AllSimoSubs}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/view"
                    exact
                    component={ViewSimoSub}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/edit"
                    exact
                    component={EditSimoSub}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/activate"
                    exact
                    component={SimoActivateSub}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/update-plan"
                    exact
                    component={SimoUpdatePlan}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/upcoming-plan"
                    exact
                    component={SimoSetUpcomingPlan}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/modify-auto-renew"
                    exact
                    component={SimoAutoRenew}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/expire-subscription"
                    exact
                    component={SimoExpireSubscription}
                  />
                  <Route
                    path="/simo/subscriptions/search"
                    exact
                    component={SearchSimoSubs}
                  />
                  <Route
                    path="/simo/subscriptions/search/page/:page"
                    exact
                    component={SearchSimoSubs}
                  />
                  <Route
                    path="/simo/subscriptions/activation-renewal"
                    exact
                    component={SimoActivationRenewal}
                  />
                  <Route
                    path="/simo/subscriptions/activation-renewal/page/:page"
                    exact
                    component={SimoActivationRenewal}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/new-lease"
                    exact
                    component={SimoNewLease}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/leases"
                    exact
                    component={SimoSubLeases}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/update-lease/:leaseId"
                    exact
                    component={SimoUpdateLease}
                  />
                  <Route
                    path="/simo/subscriptions/:subId/upgrade-invoice"
                    exact
                    component={SimoUpgradeInvoice}
                  />
                  {/* <Route path="/simo/subscriptions/:subId/add-top-up" exact component={SimoTopUps} />
                  <Route path="/simo/subscriptions/:subId/top-up-invoice" exact component={GenTopUpInvoice} /> */}
                  <Route
                    path="/simo/devices"
                    exact
                    component={AllSimoDevices}
                  />
                  <Route
                    path="/simo/devices/search"
                    exact
                    component={SearchSimoDevices}
                  />
                  <Route
                    path="/simo/devices/:deviceId/view"
                    exact
                    component={ViewSimoDevice}
                  />
                  <Route
                    path="/simo/devices/:deviceId/transfer"
                    exact
                    component={TransferSimoDevice}
                  />
                  <Route
                    path="/users/:userId/quick/new-subscription"
                    exact
                    component={QuickCreateSub}
                  />
                  <Route
                    path="/quick/subscriptions"
                    exact
                    component={AllQuickSubs}
                  />
                  <Route
                    path="/quick/pre-activation"
                    exact
                    component={QuickPreActivations}
                  />
                  <Route
                    path="/quick/port-outs"
                    exact
                    component={QuickPortOuts}
                  />
                  <Route
                    path="/quick/subscriptions/page/:page"
                    exact
                    component={AllQuickSubs}
                  />
                  <Route
                    path="/quick/subscriptions/search"
                    exact
                    component={SearchQuickSubs}
                  />
                  <Route
                    path="/quick/subscriptions/search/page/:page"
                    exact
                    component={SearchQuickSubs}
                  />
                  <Route
                    path="/quick/subscriptions/:subId/view"
                    exact
                    component={ViewQuickSub}
                  />
                  <Route
                    path="/quick/subscriptions/:subId/new-port"
                    exact
                    component={QuickNewPort}
                  />
                  <Route
                    path="/quick/subscriptions/:subId/update-port"
                    exact
                    component={QuickUpdatePort}
                  />
                  <Route
                    path="/quick/subscriptions/:subId/port-cancel"
                    exact
                    component={QuickPortCancel}
                  />
                  <Route
                    path="/quick/subscriptions/:subId/transfer-subscription"
                    exact
                    component={QuickTransferSubscription}
                  />
                  <Route
                    path="/quick/subscriptions/:subId/contracts/create-contract"
                    exact
                    component={QuickCreateContract}
                  />
                  <Route
                    path="/quick/subscriptions/:subId/verification-code"
                    exact
                    component={QuickVerificationCode}
                  />
                  <Route
                    path="/quick/subscriptions/:subId/carrier-requests"
                    exact
                    component={QuickCarrierRequests}
                  />
                  <Route
                    path="/quick/subscriptions/:subId/mdn-history"
                    exact
                    component={QuickMdnHistory}
                  />
                  <Route path="/subscriptions" exact component={AllSubs} />
                  <Route
                    path="/subscriptions/page/:page"
                    exact
                    component={AllSubs}
                  />
                  <Route
                    path="/subscriptions/search"
                    exact
                    component={SearchSubs}
                  />
                  <Route
                    path="/subscriptions/search/page/:page"
                    exact
                    component={SearchSubs}
                  />
                  <Route
                    path="/subscriptions/:subId/view"
                    exact
                    component={ViewSub}
                  />
                  <Route
                    path="/subscriptions/:subId/leases"
                    exact
                    component={SubLeases}
                  />
                  <Route
                    path="/subscriptions/:subId/update-port"
                    exact
                    component={UpdatePort}
                  />
                  <Route
                    path="/subscriptions/:subId/port-modify"
                    exact
                    component={PortModify}
                  />
                  <Route
                    path="/subscriptions/:subId/new-port"
                    exact
                    component={NewPort}
                  />
                  <Route
                    path="/subscriptions/:subId/usage/calls"
                    exact
                    component={SprintCallRecords}
                  />
                  <Route
                    path="/subscriptions/:subId/daily-usage"
                    exact
                    component={DailyUsagePage}
                  />
                  <Route
                    path="/subscriptions/:subId/port-info"
                    exact
                    component={ViewPortInfo}
                  />
                  <Route
                    path="/subscriptions/:subId/activate-new-mdn"
                    exact
                    component={NewMdnActivationForm}
                  />
                  <Route
                    path="/subscriptions/:subId/activate"
                    exact
                    component={ActivateSub}
                  />
                  <Route
                    path="/subscriptions/:subId/start-switch-to-att"
                    exact
                    component={SwitchToAtt}
                  />
                  <Route
                    path="/subscriptions/:subId/confirm-switch-to-att"
                    exact
                    component={SwitchToAtt}
                  />
                  <Route
                    path="/subscriptions/:subId/port-cancel"
                    exact
                    component={PortCancel}
                  />
                  <Route
                    path="/subscriptions/:subId/update-lease/:leaseId"
                    exact
                    component={UpdateLease}
                  />
                  <Route
                    path="/device-protection/contracts"
                    exact
                    component={AllInsuranceContracts}
                  />
                  <Route
                    path="/device-protection/contracts/:id/view"
                    exact
                    component={ViewContract}
                  />
                  <Route
                    path="/device-protection/contracts/:id/update"
                    exact
                    component={UpdateContract}
                  />
                  <Route
                    path="/device-protection/contracts/:id/add-device"
                    exact
                    component={CreateDevice}
                  />
                  <Route
                    path="/device-protection/devices/:id/view"
                    exact
                    component={ViewDevice}
                  />
                  <Route
                    path="/leases/:leaseId/view"
                    exact
                    component={ViewLease}
                  />
                  <Route
                    path="/device/contracts/:deviceContractId/view"
                    exact
                    component={ViewDeviceContract}
                  />
                  <Route path="/shippings" exact component={ShippingEstimate} />
                  <Route path="/reseller" exact component={Reseller} />
                  <Route path="/reseller/att" exact component={AttReseller} />
                  <Route path="/subs" exact component={SubSearch} />
                  <Route
                    path="/custom-plan-prices"
                    exact
                    component={CustomPlanPricing}
                  />
                  <Route
                    path="/custom-plan-prices/new"
                    exact
                    component={CreateCustomPlanPricing}
                  />
                  <Route
                    path="/custom-plan-prices/:planId/"
                    exact
                    component={ViewCustomPlanPricing}
                  />
                  <Route
                    path="/mass-actions/purchases"
                    exact
                    component={PurchaseMassActions}
                  />
                  <Route
                    path="/mass-actions/att"
                    exact
                    component={AttMassActions}
                  />
                  <Route
                    path="/mass-actions/simo"
                    exact
                    component={SimoMassActions}
                  />
                  <Route
                    path="/mass-actions/quick"
                    exact
                    component={QuickMassActions}
                  />
                </Switch>
              )}
              {!isLoggedIn && <Login onLogin={() => this.render()} />}
            </div>
          </div>
          <Intercom
            appID={INTERCOM_ID}
            user_id={user.id}
            email={user.email}
            name={user.first_name}
          />
          <ToastContainer autoClose={false} />
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoggedIn: getIsLoggedIn(state),
  user: getLoggedInUser(state),
  loggedInUser: getLoggedInUser(state),
});

const mapDispatchToProps = {
  loginCheck,
  logout,
};

App = connect(mapStateToProps, mapDispatchToProps)(App);

export default App;
